// constants
import { SubActionTypes } from "./constants";

export interface SubActionType {
  type:
    | SubActionTypes.API_RESPONSE_SUCCESS
    | SubActionTypes.API_RESPONSE_ERROR
    | SubActionTypes.GET_SUB
    | SubActionTypes.DELETE_SUB;
  payload: {} | string;
}

interface SubDetails {
  id: string;
  email: string;
}

// common success
export const subApiResponseSuccess = (
  actionType: string,
  data: SubDetails | {}
): SubActionType => ({
  type: SubActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const subApiResponseError = (
  actionType: string,
  error: string
): SubActionType => ({
  type: SubActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getSub = (): SubActionType => ({
  type: SubActionTypes.GET_SUB,
  payload: {},
});

export const deleteSub = (id: string): SubActionType => ({
  type: SubActionTypes.DELETE_SUB,
  payload: { id },
});
